<template>
  <main class="wrestling-bracket-page" dir="rtl">

    <!-- سربرگ شیک و خلوت مسابقات -->
    <header class="page-header">
      <div class="header-main">
        <div class="title-wrap">
          <h1>مسابقات کشتی قهرمانی جهان قزاقستان ۲۰۲۶</h1>
<!--          <p class="subtitle">نمودار درختی و نتایج زندهٔ ۲۰ وزن کشتی فرنگی و آزاد در سالن باریس آرنا (آستانه)</p>-->
        </div>
      </div>
      <div class="header-top">
        <!--        <div class="live-pill">-->
        <!--          <span class="pulse-dot"></span>-->
        <!--          <span>نتایج رسمی اتحادیه جهانی کشتی (UWW)</span>-->
        <!--        </div>-->
        <div class="header-actions">
          <span class="last-sync">آخرین استعلام: {{ lastUpdatedText }}</span>
          <button class="btn-refresh" :disabled="loadingCategories || loadingMatches" @click="refreshCurrentWeight"
                  title="تازه‌سازی">
            <span :class="{ 'spin': loadingMatches }">🔄</span>
            <span class="btn-text">بروزرسانی</span>
          </button>
        </div>
      </div>
    </header>

    <!-- اسلایدر اخبار مخصوص کشتی — بالای تب‌های سبک -->
    <WrestlingNewsSlider />

    <!-- انتخاب سبک (فرنگی، آزاد) -->
    <nav class="style-tabs" aria-label="سبک‌های کشتی">
      <button
          v-for="st in styles"
          :key="st.code"
          class="tab-btn"
          :class="{ 'active': selectedStyle === st.code }"
          @click="selectStyle(st.code)"
      >
        <span class="tab-label">{{ st.label }}</span>
        <span class="tab-badge" v-if="styleMatchesCount(st.code) > 0">
          {{ styleMatchesCount(st.code) }} مبارزه
        </span>
      </button>
    </nav>

    <!-- انتخاب وزن (Pills) -->
    <section class="weight-selector-section" aria-label="انتخاب وزن">
      <div class="weights-scroller">
        <button
            v-for="cat in currentStyleCategories"
            :key="cat.id"
            class="weight-pill"
            :class="{
            'active': selectedCategory && selectedCategory.id === cat.id,
            'has-matches': cat.countMatches > 0,
            'is-done': cat.isCompleted
          }"
            @click="selectCategory(cat)"
        >
          <span class="weight-num">{{ cat.weight }}</span>
          <span class="weight-unit">کیلوگرم</span>
          <img class="iran-marker" src="https://flagcdn.com/w40/ir.png" alt="ایران" v-if="hasIranInWeight(cat.id)"
               title="حضور نماینده ایران">
          <span class="dot-indicator" v-else-if="cat.countMatches > 0" title="دارای مسابقه"></span>
        </button>
      </div>
    </section>

    <!-- بخش بدنه: اطلاعات وزن انتخاب شده + نمودار درختی -->
    <section class="bracket-container" v-if="selectedCategory">

      <!-- نوار خلاصه وزن انتخاب‌شده -->
      <div class="weight-info-banner">
        <div class="wib-title">
          <h2>{{ selectedCategory.sportFa }} — وزن {{ selectedCategory.weight }} کیلوگرم</h2>
          <span class="wib-status" :class="{ 'live': weightLive, 'done': weightDone }">
            {{
              weightDone ? (weightDonePending ? '✓ پایان‌یافته — در انتظار ثبت نتیجه در UWW' : '✓ رقابت‌ها به پایان رسیده') : (weightLive ? '🔴 در حال برگزاری' : 'برنامه پیش‌رو')
            }}
          </span>
        </div>
        <div class="wib-meta">
          <span v-if="currentMatches.length">کل مبارزات این وزن: <strong>{{ currentMatches.length }}</strong></span>
          <span v-if="iranWeightMatches.length" class="iran-highlight-tag">
            🇮🇷 {{ iranWeightMatches.length }} مسابقه با حضور دلاوران ایران
          </span>
        </div>
      </div>

      <!-- وضعیت بارگذاری -->
      <div v-if="loadingMatches" class="loading-state">
        <div class="spinner"></div>
        <p>در حال دریافت آخرین براکت و نمودار درختی از اتحادیه جهانی کشتی…</p>
      </div>

      <!-- اگر برای این وزن هنوز مسابقه‌ای ثبت نشده -->
      <div v-else-if="!currentMatches.length" class="empty-bracket">
        <span class="empty-icon">🤼‍♂️</span>
        <h3>هنوز جدول مسابقات این وزن قرعه‌کشی نشده یا مسابقات آن آغاز نشده است</h3>
        <p>به‌محض انتشار قرعه‌کشی رسمی توسط UWW، نمودار درختی به‌صورت لحظه‌ای در همین بخش قرار می‌گیرد.</p>
      </div>

      <!-- نمودار درختی رسمی مسابقات با کتابخانه vue-tournament-bracket -->
      <WrestlingBracket
          v-else
          :matches="currentMatches"
          @match-click="openMatchModal"
      />

    </section>

    <!-- رتبه‌بندی تیمی مسابقات — آزاد و فرنگی کنار هم -->
    <WrestlingTeamStandings />

    <!-- مودال اختصاصی جزئیات مسابقه و اطلاعات کشتی‌گیران -->
    <div class="modal-backdrop" v-if="activeModalMatch" @click.self="closeMatchModal">
      <div class="match-modal-card">
        <button class="modal-close-btn" @click="closeMatchModal" aria-label="بستن">✕</button>

        <div class="modal-header">
          <span class="modal-round-tag">{{ activeModalMatch.roundFa || activeModalMatch.round }}</span>
          <h3>مبارزه شماره {{ activeModalMatch.number }} (تشک {{ activeModalMatch.mat }})</h3>
          <span class="modal-weight-tag">{{ selectedCategory.sportFa }} • {{ selectedCategory.weight }} کیلوگرم</span>
        </div>

        <div class="modal-athletes-compare">
          <!-- گوشه قرمز -->
          <div class="modal-athlete-col red" :class="{ 'winner': activeModalMatch.red.isWinner }">
<!--            <div class="corner-badge red">گوشه قرمز (RED)</div>-->
            <div class="athlete-avatar-wrap">
              <img v-if="activeModalMatch.red.photo" :src="activeModalMatch.red.photo" :alt="activeModalMatch.red.name">
              <img v-else :src="activeModalMatch.red.flagUrl || neutralFlag"
                   :alt="activeModalMatch.red.countryFa || ''">
            </div>
            <div class="athlete-names">
              <h4>{{ activeModalMatch.red.nameFa || activeModalMatch.red.name || 'نامشخص' }}</h4>
              <span class="en-name" v-if="activeModalMatch.red.name">{{ activeModalMatch.red.name }}</span>
            </div>
            <div class="country-pill">
              <img class="flag-img" :src="activeModalMatch.red.flagUrl || neutralFlag"
                   :alt="activeModalMatch.red.countryFa || ''" @error="onFlagError">
              <span>{{
                  activeModalMatch.red.countryFa || activeModalMatch.red.country || activeModalMatch.red.code
                }}</span>
            </div>
            <div class="modal-score" :class="{ 'winner-score': activeModalMatch.red.isWinner }">
              {{ activeModalMatch.red.points !== null ? activeModalMatch.red.points : '-' }}
            </div>
            <div class="winner-stamp" v-if="activeModalMatch.red.isWinner">
              🏆 برنده مسابقه
            </div>
          </div>

          <!-- مرکز: وضعیت و نوع پیروزی -->
          <div class="modal-vs-center">
            <span class="vs-badge">VS</span>
            <div class="verdict-box" v-if="activeModalMatch.victoryTypeFa">
              <span class="verdict-title">نوع پیروزی:</span>
              <span class="verdict-val">{{ activeModalMatch.victoryTypeFa }}</span>
              <small class="verdict-code" v-if="activeModalMatch.victoryType">({{
                  activeModalMatch.victoryType
                }})</small>
            </div>
            <div class="status-box">
              <span v-if="activeModalMatch.isCompleted" class="status-done">خاتمه‌یافته</span>
              <span v-else-if="modalOverdue" class="status-done">در انتظار ثبت نتیجه در UWW</span>
              <span v-else class="status-live">در حال برگزاری / پیش‌رو</span>
            </div>
          </div>

          <!-- گوشه آبی -->
          <div class="modal-athlete-col blue" :class="{ 'winner': activeModalMatch.blue.isWinner }">
<!--            <div class="corner-badge blue">گوشه آبی (BLUE)</div>-->
            <div class="athlete-avatar-wrap">
              <img v-if="activeModalMatch.blue.photo" :src="activeModalMatch.blue.photo"
                   :alt="activeModalMatch.blue.name">
              <img v-else :src="activeModalMatch.blue.flagUrl || neutralFlag"
                   :alt="activeModalMatch.blue.countryFa || ''">
            </div>
            <div class="athlete-names">
              <h4>{{ activeModalMatch.blue.nameFa || activeModalMatch.blue.name || 'نامشخص' }}</h4>
              <span class="en-name" v-if="activeModalMatch.blue.name">{{ activeModalMatch.blue.name }}</span>
            </div>
            <div class="country-pill">
              <img class="flag-img" :src="activeModalMatch.blue.flagUrl || neutralFlag"
                   :alt="activeModalMatch.blue.countryFa || ''" @error="onFlagError">
              <span>{{
                  activeModalMatch.blue.countryFa || activeModalMatch.blue.country || activeModalMatch.blue.code
                }}</span>
            </div>
            <div class="modal-score" :class="{ 'winner-score': activeModalMatch.blue.isWinner }">
              {{ activeModalMatch.blue.points !== null ? activeModalMatch.blue.points : '-' }}
            </div>
            <div class="winner-stamp" v-if="activeModalMatch.blue.isWinner">
              🏆 برنده مسابقه
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <span>منبع رسمی: پایگاه داده اتحادیه جهانی کشتی (UWW)</span>
          <button class="btn-modal-close" @click="closeMatchModal">بستن</button>
        </div>
      </div>
    </div>

  </main>
</template>

<script>
import api from '@/services/api';
import {setSeo} from '@/utils/seo';
import WrestlingBracket from '@/components/WrestlingBracket.vue';
import WrestlingNewsSlider from '@/components/WrestlingNewsSlider.vue';
import WrestlingTeamStandings from '@/components/WrestlingTeamStandings.vue';

// پرچم خنثی SVG داخلی (فال‌بک وقتی flagcdn در دسترس نیست)
const NEUTRAL_FLAG = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(
    "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 20'><rect width='30' height='20' fill='#e2e8f0'/><text x='15' y='14' font-size='11' text-anchor='middle' fill='#94a3b8'>؟</text></svg>"
);

// آستانهٔ «دیرهنگام» — مسابقهٔ کشتی حداکثر ~۱۵ دقیقه است؛ اگر یک ساعت از زمان شروع
// برنامه‌ریزی‌شده بگذرد و هنوز برنده‌ای در فید UWW ثبت نشده باشد، یعنی نتیجه دیر ثبت می‌شود
const OVERDUE_MS = 60 * 60 * 1000;

function isOverdue(match) {
  if (!match || match.isCompleted || !match.expectedStartTime) return false;
  const t = new Date(match.expectedStartTime).getTime();
  if (!t || Number.isNaN(t)) return false;
  return Date.now() - t > OVERDUE_MS;
}

export default {
  name: 'SpecialEvents',
  components: {WrestlingBracket, WrestlingNewsSlider, WrestlingTeamStandings},
  data() {
    return {
      categories: [],
      iranOverview: null,
      selectedStyle: 'gr', // پیش‌فرض: کشتی فرنگی
      selectedCategory: null,
      currentMatches: [],
      activeModalMatch: null,
      loadingCategories: true,
      loadingMatches: false,
      lastUpdated: new Date(),
      autoRefreshTimer: null,
      neutralFlag: NEUTRAL_FLAG,
      styles: [
        {code: 'gr', label: 'کشتی فرنگی', icon: '🤼‍♂️'},
        {code: 'fs', label: 'کشتی آزاد', icon: '🤼'},
      ],
    };
  },
  computed: {
    lastUpdatedText() {
      const d = this.lastUpdated;
      const h = String(d.getHours()).padStart(2, '0');
      const m = String(d.getMinutes()).padStart(2, '0');
      const s = String(d.getSeconds()).padStart(2, '0');
      return `${h}:${m}:${s}`;
    },
    currentStyleCategories() {
      return this.categories
          .filter(c => c.sport === this.selectedStyle)
          .sort((a, b) => a.weight - b.weight);
    },
    iranMatches() {
      return this.iranOverview?.iranMatches || [];
    },
    iranWeightMatches() {
      if (!this.selectedCategory) return [];
      return this.currentMatches.filter(m => m.hasIran);
    },
    // وضعیت پایان: پرچم UWW یا فالبک داده‌محور — اگر همهٔ مبارزات برنده دارند، قطعاً تمام شده
    // (پرچم is_completed اتحادیه گاهی ساعت‌ها بعد از فینال به‌روز می‌شود)
    weightDone() {
      if (!this.selectedCategory) return false;
      if (this.selectedCategory.isCompleted) return true;
      if (!this.currentMatches.length) return false;
      if (this.currentMatches.every(m => m.isCompleted)) return true;
      // فالبک زمانی: اگر همهٔ بازی‌های بدون‌برنده، زمان شروع‌شان خیلی گذشته باشد
      // (مسابقهٔ کشتی حداکثر ~۱۵ دقیقه است) → پایان‌یافته ولی هنوز در انتظار ثبت UWW
      const pending = this.currentMatches.filter(m => !m.isCompleted);
      return pending.length > 0 && pending.every(m => isOverdue(m));
    },
    // پایان‌یافته ولی هنوز نتایج همه در UWW ثبت نشده (نمایش برچسب متمایز)
    weightDonePending() {
      return this.weightDone && this.currentMatches.some(m => !m.isCompleted);
    },
    weightLive() {
      if (!this.selectedCategory || this.weightDone) return false;
      return !!this.selectedCategory.isStarted;
    },
    modalOverdue() {
      return isOverdue(this.activeModalMatch);
    },
  },
  async created() {
    setSeo({
      title: 'جدول کشتی و نتایج زنده قهرمانی جهان ۲۰۲۶ | جدول رسیدن تا فینال پهلوانان ایرانی | ضربه آزاد',
      description: 'جدول کشتی مسابقات قهرمانی جهان ۲۰۲۶ آستانه؛ جدول رسیدن تا فینال پهلوانان ایرانی، نتایج زنده اوزان کشتی آزاد و کشتی فرنگی و قرعه هر دور با استعلام مستقیم از UWW',
      path: '/special',
    });

    await this.init();
    this.startAutoRefresh();
  },
  beforeDestroy() {
    this.stopAutoRefresh();
  },
  methods: {
    async init() {
      await Promise.all([
        this.fetchCategories(),
        this.fetchOverview(),
      ]);
    },
    async fetchCategories(force = false) {
      this.loadingCategories = true;
      try {
        const res = await api.request(`/wrestling/categories${force ? '?force=1' : ''}`);
        if (res && res.success) {
          this.categories = res.data || [];
          if (this.selectedCategory) {
            // همگام‌سازی مرجع دستهٔ انتخاب‌شده با لیست تازه، تا وضعیت «پایان‌یافته/درحال‌برگزاری» بروز بماند
            const fresh = this.categories.find(c => c.id === this.selectedCategory.id);
            if (fresh) this.selectedCategory = fresh;
          } else {
            // پیدا کردن اولین وزن دارای مسابقه فرنگی یا اولین وزن
            const activeGr = this.categories.find(c => c.sport === this.selectedStyle && c.countMatches > 0);
            const firstGr = this.categories.find(c => c.sport === this.selectedStyle);
            const initial = activeGr || firstGr || this.categories[0];
            if (initial) {
              this.selectCategory(initial);
            }
          }
        }
      } catch (err) {
        console.error('fetchCategories error:', err);
      } finally {
        this.loadingCategories = false;
      }
    },
    async fetchOverview() {
      try {
        const res = await api.request('/wrestling/overview');
        if (res && res.success) {
          this.iranOverview = res.data;
        }
      } catch (err) {
        console.error('fetchOverview error:', err);
      }
    },
    async selectStyle(code) {
      this.selectedStyle = code;
      const cats = this.categories.filter(c => c.sport === code);
      const activeCat = cats.find(c => c.countMatches > 0) || cats[0];
      if (activeCat) {
        this.selectCategory(activeCat);
      } else {
        this.selectedCategory = null;
        this.currentMatches = [];
      }
    },
    async selectCategory(cat) {
      this.selectedCategory = cat;
      await this.fetchMatches(cat.id);
    },
    async fetchMatches(catId, force = false) {
      if (!catId) return;
      this.loadingMatches = true;
      try {
        const res = await api.request(`/wrestling/matches/${catId}${force ? '?force=1' : ''}`);
        if (res && res.success) {
          this.currentMatches = res.data.matches || [];
          this.lastUpdated = new Date();
        }
      } catch (err) {
        console.error('fetchMatches error:', err);
        this.currentMatches = [];
      } finally {
        this.loadingMatches = false;
      }
    },
    async refreshCurrentWeight() {
      if (!this.selectedCategory) return;
      await Promise.all([
        this.fetchMatches(this.selectedCategory.id, true),
        this.fetchOverview(),
        this.fetchCategories(true),
      ]);
    },
    hasIranInWeight(catId) {
      return this.iranMatches.some(m => m.weightId === catId);
    },
    styleMatchesCount(sportCode) {
      return this.categories
          .filter(c => c.sport === sportCode)
          .reduce((sum, c) => sum + (c.countMatches || 0), 0);
    },
    onFlagError(e) {
      // فال‌بک: اگر پرچم بارگذاری نشد، پرچم خنثی نشان بده
      if (e && e.target && e.target.src !== this.neutralFlag) {
        e.target.src = this.neutralFlag;
      }
    },
    openMatchModal(match) {
      this.activeModalMatch = match;
    },
    closeMatchModal() {
      this.activeModalMatch = null;
    },
    startAutoRefresh() {
      this.stopAutoRefresh();
      // استعلام خودکار هر ۶۰ ثانیه
      // دسته‌ها هم هر بار استعلام می‌شوند (بدون force؛ کش بک‌اند ۵ دقیقه‌ای) تا
      // وضعیت «در حال برگزاری / پایان‌یافته» اوزان مثل قبل منجمد نشود
      this.autoRefreshTimer = setInterval(() => {
        if (this.selectedCategory) {
          this.fetchMatches(this.selectedCategory.id);
        }
        this.fetchCategories();
      }, 60000);
    },
    stopAutoRefresh() {
      if (this.autoRefreshTimer) {
        clearInterval(this.autoRefreshTimer);
        this.autoRefreshTimer = null;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.wrestling-bracket-page {
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 20px 16px 60px;
  box-sizing: border-box;
  font-family: system-ui, -apple-system, 'Vazirmatn', Tahoma, sans-serif;
  color: #0f172a;
}

/* ---------------------------------------------------
   سربرگ صفحه
--------------------------------------------------- */
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(135deg, #022c22 0%, #064e3b 55%, #047857 100%);
  border-radius: 20px;
  padding: 22px 24px;
  color: #fff;
  margin-bottom: 20px;
  box-shadow: 0 10px 30px rgba(2, 44, 34, 0.2);
}

.header-top {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 12px;
  flex-wrap: wrap;
  gap: 10px;
}

.live-pill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(239, 68, 68, 0.2);
  border: 1px solid rgba(239, 68, 68, 0.5);
  color: #fecaca;
  font-size: 0.8rem;
  font-weight: 700;
  padding: 4px 12px;
  border-radius: 100px;
}

.pulse-dot {
  width: 8px;
  height: 8px;
  background: #ef4444;
  border-radius: 50%;
  animation: pulse 1.4s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(0.9);
    opacity: 0.8;
  }
  50% {
    transform: scale(1.4);
    opacity: 1;
  }
  100% {
    transform: scale(0.9);
    opacity: 0.8;
  }
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.last-sync {
  font-size: 0.8rem;
  color: #a7f3d0;
}

.btn-refresh {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.25);
  color: #fff;
  padding: 6px 14px;
  border-radius: 8px;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s, transform 0.1s;

  &:hover {
    background: rgba(255, 255, 255, 0.25);
  }

  .spin {
    display: inline-block;
    animation: spin 1s linear infinite;
  }
}

@keyframes spin {
  100% {
    transform: rotate(-360deg);
  }
}

.header-main h1 {
  margin: 0 0 6px;
  font-size: 1.40rem;
  font-weight: 700;
  line-height: 1.35;
}

.header-main .subtitle {
  margin: 0;
  font-size: 0.92rem;
  color: #d1fae5;
  line-height: 1.6;
}

/* ---------------------------------------------------
   تب‌های سبک (فرنگی، آزاد)
--------------------------------------------------- */
.style-tabs {
  display: flex;
  gap: 10px;
  margin-bottom: 14px;
}

.tab-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 16px;
  background: #ffffff;
  border: 2px solid #e2e8f0;
  border-radius: 14px;
  font-size: 1rem;
  font-weight: 700;
  color: #475569;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    border-color: #cbd5e1;
    background: #f8fafc;
  }

  &.active {
    background: #022c22;
    border-color: #022c22;
    color: #ffffff;
    box-shadow: 0 4px 14px rgba(2, 44, 34, 0.18);
  }

  .tab-icon {
    font-size: 1.25rem;
  }

  .tab-badge {
    background: rgba(16, 185, 129, 0.15);
    color: #047857;
    font-size: 0.75rem;
    padding: 2px 8px;
    border-radius: 100px;
    font-weight: 700;
  }

  &.active .tab-badge {
    background: rgba(255, 255, 255, 0.2);
    color: #a7f3d0;
  }
}

/* ---------------------------------------------------
   انتخاب وزن‌ها (Pills)
--------------------------------------------------- */
.weight-selector-section {
  border-radius: 14px;
  padding: 10px 14px;
  margin-bottom: 20px;
}

.weights-scroller {
  display: flex;
  gap: 8px;
  overflow-x: auto;
  padding: 4px 2px;
  scrollbar-width: thin;

  &::-webkit-scrollbar {
    height: 5px;
  }

  &::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 10px;
  }
}

.weight-pill {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 13px;
  background: #f8fafc;
  border: 1.5px solid #e2e8f0;
  border-radius: 10px;
  cursor: pointer;
  font-size: 0.95rem;
  font-weight: 700;
  color: #334155;
  transition: all 0.2s;
  position: relative;

  &:hover {
    border-color: #94a3b8;
    background: #f1f5f9;
  }

  &.active {
    background: #022c22;
    border-color: #022c22;
    color: #ffffff;
    box-shadow: 0 4px 12px rgba(4, 120, 87, 0.25);
  }

  .weight-unit {
    font-size: 0.75rem;
    font-weight: 500;
    opacity: 0.8;
  }

  .iran-marker {
    width: 20px;
    height: 13px;
    object-fit: cover;
    border-radius: 2px;
    border: 1px solid rgba(15, 23, 42, 0.12);
    flex-shrink: 0;
  }

  .dot-indicator {
    width: 6px;
    height: 6px;
    background: #10b981;
    border-radius: 50%;
  }

  &.active .dot-indicator {
    background: #ffffff;
  }
}

/* ---------------------------------------------------
   کانتینر نمودار درختی (Bracket Container)
--------------------------------------------------- */
.bracket-container {
  background: inherit;
  border-radius: 18px;
  border: none;
  padding: 20px;
  //box-shadow: 0 4px 20px rgba(0, 0, 0, 0.03);
}

.weight-info-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #f1f5f9;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 12px;
  background: #ffffff;
  padding: 8px 12px;
  border-radius: 10px;
}

.wib-title {
  display: flex;
  align-items: center;
  gap: 12px;

  h2 {
    margin: 0;
    font-size: 1.25rem;
    font-weight: 800;
    color: #0f172a;
  }
}

.wib-status {
  font-size: 0.8rem;
  font-weight: 700;
  padding: 3px 10px;
  border-radius: 100px;
  background: #f1f5f9;
  color: #64748b;

  &.live {
    background: #fee2e2;
    color: #b91c1c;
  }

  &.done {
    background: #dcfce7;
    color: #15803d;
  }
}

.wib-meta {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 0.88rem;
  color: #64748b;
}

.iran-highlight-tag {
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  color: #166534;
  padding: 4px 10px;
  border-radius: 8px;
  font-weight: 700;
}

/* وضعیت لودینگ و خالی */
.loading-state, .empty-bracket {
  text-align: center;
  padding: 60px 20px;
  color: #64748b;

  .spinner {
    width: 36px;
    height: 36px;
    border: 3px solid #e2e8f0;
    border-top-color: #047857;
    border-radius: 50%;
    margin: 0 auto 16px;
    animation: spin 0.8s linear infinite;
  }

  .empty-icon {
    font-size: 3rem;
    display: block;
    margin-bottom: 12px;
  }

  h3 {
    margin: 0 0 8px;
    font-size: 1.1rem;
    color: #1e293b;
  }

  p {
    margin: 0;
    font-size: 0.9rem;
  }
}

/* ---------------------------------------------------
   پرچم تصویری (سراسری — کارت‌ها و مودال)
--------------------------------------------------- */
.flag-img {
  width: 26px;
  height: 17px;
  object-fit: cover;
  border-radius: 3px;
  border: 1px solid rgba(15, 23, 42, 0.14);
  flex-shrink: 0;
  background: #f1f5f9;
  display: block;
}

/* ---------------------------------------------------
   مودال جزئیات مسابقه و کشتی‌گیران
--------------------------------------------------- */
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(15, 23, 42, 0.7);
  backdrop-filter: blur(4px);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

.match-modal-card {
  background: #ffffff;
  border-radius: 20px;
  max-width: 680px;
  width: 100%;
  padding: 24px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  position: relative;
  max-height: 90vh;
  overflow-y: auto;
}

.modal-close-btn {
  position: absolute;
  top: 16px;
  left: 16px;
  background: #f1f5f9;
  border: none;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  font-size: 1rem;
  color: #64748b;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: #e2e8f0;
    color: #0f172a;
  }
}

.modal-header {
  text-align: center;
  margin-bottom: 24px;

  .modal-round-tag {
    display: inline-block;
    background: #ecfdf5;
    color: #047857;
    font-size: 0.8rem;
    font-weight: 700;
    padding: 3px 12px;
    border-radius: 100px;
    margin-bottom: 6px;
  }

  h3 {
    margin: 4px 0;
    font-size: 1.3rem;
    font-weight: 800;
    color: #0f172a;
  }

  .modal-weight-tag {
    font-size: 0.85rem;
    color: #64748b;
  }
}

.modal-athletes-compare {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 24px;
}

.modal-athlete-col {
  flex: 1;
  background: #f8fafc;
  border: 2px solid #e2e8f0;
  border-radius: 16px;
  padding: 18px 12px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap:20px;
  min-height: 365px;

  &.red {
    border-top: 5px solid #ef4444;
  }

  &.blue {
    border-top: 5px solid #3b82f6;
  }

  &.winner {
    background: #f0fdf4;
    border-color: #10b981;
    border-top-width: 5px;
  }
}

.corner-badge {
  font-size: 0.72rem;
  font-weight: 800;
  padding: 2px 8px;
  border-radius: 4px;
  margin-bottom: 10px;

  &.red {
    background: #fee2e2;
    color: #b91c1c;
  }

  &.blue {
    background: #dbeafe;
    color: #1d4ed8;
  }
}

.athlete-avatar-wrap {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  overflow: hidden;
  background: #e2e8f0;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.athlete-names h4 {
  margin: 0 0 4px;
  font-size: 1rem;
  font-weight: 800;
  color: #0f172a;
}

.athlete-names .en-name {
  font-size: 0.78rem;
  color: #64748b;
  display: block;
  margin-bottom: 8px;
}

.country-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  padding: 3px 10px;
  border-radius: 100px;
  font-size: 0.8rem;
  font-weight: 700;
  margin-bottom: 12px;
}

.modal-score {
  font-size: 2rem;
  font-weight: 900;
  color: #475569;
  line-height: 1;
  margin-bottom: 6px;

  &.winner-score {
    color: #047857;
  }
}

.winner-stamp {
  background: #dcfce7;
  color: #15803d;
  font-size: 0.78rem;
  font-weight: 800;
  padding: 3px 10px;
  border-radius: 100px;
  margin-top: 6px;
}

.modal-vs-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  min-width: 120px;
  text-align: center;
}

.vs-badge {
  font-size: 1.1rem;
  font-weight: 900;
  color: #94a3b8;
  letter-spacing: 1px;
}

.verdict-box {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 8px 12px;

  .verdict-title {
    display: block;
    font-size: 0.7rem;
    color: #64748b;
    margin-bottom: 2px;
  }

  .verdict-val {
    display: block;
    font-size: 0.85rem;
    font-weight: 800;
    color: #0f172a;
  }

  .verdict-code {
    display: block;
    font-size: 0.7rem;
    color: #94a3b8;
  }
}

.status-box {
  font-size: 0.78rem;
  font-weight: 700;

  .status-done {
    color: #15803d;
  }

  .status-live {
    color: #b91c1c;
  }
}

.modal-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid #f1f5f9;
  padding-top: 16px;
  font-size: 0.8rem;
  color: #94a3b8;
}

.btn-modal-close {
  background: #047857;
  color: #ffffff;
  border: none;
  padding: 8px 18px;
  border-radius: 8px;
  font-weight: 700;
  font-size: 0.85rem;
  cursor: pointer;

  &:hover {
    background: #065f46;
  }
}

/* ---------------------------------------------------
   واکنش‌گرایی موبایل
--------------------------------------------------- */
@media (max-width: 768px) {
  .wrestling-bracket-page {
    padding: 12px 10px 40px;
  }

  .page-header {
    padding: 16px 14px;
    border-radius: 16px;
  }

  .header-main h1 {
    font-size: 1.25rem;
  }

  .style-tabs {
    flex-direction: column;
    gap: 8px;
  }

  .bracket-container {
    padding: 14px 10px;
  }

  .modal-athletes-compare {
    flex-direction: column;
  }

  .modal-vs-center {
    order: 3;
    width: 100%;
  }

  .modal-athlete-col {
    width: 100%;
    box-sizing: border-box;
  }
}
</style>
